import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { SpaceList } from './SpaceList';
import { SpaceNew } from './SpaceNew';
import { SpaceEdit } from './SpaceEdit';
import { SpaceUsersNew } from './users/SpaceUsersNew';
import { SpaceUsersEdit } from './users/SpaceUsersEdit';
import { regHandlers } from '../../reducer';
import { Map } from 'immutable';
import { dispatch, regSaga } from '../../store';
import { navigate } from '../../root';
import { call, select, takeEvery } from 'redux-saga/effects';
import { deleteTenant } from '@kineticdata/react/src/apis/system';
import { useSelector } from 'react-redux';

regSaga(
  takeEvery('DELETE_SPACE', function*({ payload }) {
    const deleteDatabase = yield select(state =>
      state.getIn(['tenant', 'taskDelete', 'willDeleteTaskDb']),
    );
    const { error } = yield call(deleteTenant, {
      slug: payload,
      deleteDatabase,
    });
    if (!error) {
      navigate('/spaces', { replace: true });
    }
  }),
);

regHandlers({
  SET_DELETE_TASK_DB: (state, { payload }) =>
    state.updateIn(['tenant', 'taskDelete'], Map(), task =>
      task
        .set('canDeleteTaskDb', payload.canDeleteTaskDb)
        .set('willDeleteTaskDb', payload.willDeleteTaskDb),
    ),
  SET_WILL_DELETE_TASK_DB: (state, { payload }) =>
    state.setIn(
      ['tenant', 'taskDelete', 'willDeleteTaskDb'],
      typeof payload === 'boolean'
        ? payload
        : !state.getIn(['tenant', 'taskDelete', 'willDeleteTaskDb'], false),
    ),
  RESET_DELETE_TASK_DB: state => state.deleteIn(['tenant', 'taskDelete']),
});

export const toggleWillDeleteTaskDb = status =>
  dispatch('SET_WILL_DELETE_TASK_DB', status);

const SpaceDeleteConfirmationBody = () => {
  const { canDeleteTaskDb, willDeleteTaskDb } = useSelector(state => ({
    canDeleteTaskDb: state.getIn(
      ['tenant', 'taskDelete', 'canDeleteTaskDb'],
      false,
    ),
    willDeleteTaskDb: state.getIn(
      ['tenant', 'taskDelete', 'willDeleteTaskDb'],
      false,
    ),
  }));

  return (
    <div>
      Deleting a space is a permanent action. Are you sure you want to continue?
      <br />
      {canDeleteTaskDb ? (
        <>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="checkbox"
              id="delete-task-db"
              checked={willDeleteTaskDb}
              onChange={toggleWillDeleteTaskDb}
            />
            <label className="form-check-label" htmlFor="delete-task-db">
              Delete Task DB
            </label>
          </div>
          {!willDeleteTaskDb && (
            <div className="alert alert-warning">
              You are opting out of deleting the SQL database used for tasking
              and workflows. You will need to manually remove the database and
              user associated with this space before creating a new space with
              the same slug.
            </div>
          )}
        </>
      ) : (
        <div className="alert alert-warning">
          This process will not automatically delete the SQL database used for
          tasking and workflows. You will need to manually remove the database
          and user associated with this space before creating a new space with
          the same slug.
        </div>
      )}
    </div>
  );
};

export const spaceDeleteConfirmOptions = ({ spaceSlug }) => ({
  title: 'Are you sure you want to delete this Space?',
  body: SpaceDeleteConfirmationBody,
  actionName: 'Delete Space',
  actionType: 'danger',
  confirmationTextLabel: 'space slug',
  confirmationText: spaceSlug,
});

export const Spaces = () => (
  <Routes>
    <Route path="" element={<SpaceList />} />
    <Route path="new" element={<SpaceNew />} />
    <Route path="edit/:spaceSlug" element={<Navigate to="general" replace />} />
    <Route path="edit/:spaceSlug/users/new" element={<SpaceUsersNew />} />
    <Route
      path="edit/:spaceSlug/users/edit/:username"
      element={<SpaceUsersEdit />}
    />
    <Route path="edit/:spaceSlug/:tab?" element={<SpaceEdit />} />
  </Routes>
);
